import React, { ReactElement } from 'react'
import Sidebar, { SidebarProps } from '@components/Layout/Sidebar'
import Header, { HeaderProps } from '@components/Layout/Header'
import Content, { ContentProps } from '@components/Layout/Content'
import PageName from '@components/Layout/PageName'
import { Breakpoint } from '@mui/system'
import { Box } from '@mui/material'

type LayoutProps = {
  children: React.ReactNode;
  pageName?: string;
  maxWidth?: Breakpoint | false;
  headerActions?: ReactElement;
  slots?: {
    header?: Omit<HeaderProps, 'children'>;
    content?: Omit<ContentProps, 'children'>;
    sidebar?: Omit<SidebarProps, 'children'>;
  }
}

const Layout = ({ children, maxWidth, pageName, headerActions, slots }: LayoutProps) => {
  return (
    <>
      <Header {...slots?.header}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <PageName>{pageName || ''}</PageName>
          <Box sx={{ ml: 0 }}>
            {headerActions}
          </Box>
        </Box>
      </Header>
      <Sidebar {...slots?.sidebar} />
      <Content {...{ maxWidth, ...slots?.content }}>
        {children}
      </Content>
    </>
  )
}

export default Layout